<script setup>
import { inject } from 'vue';
import Saisie from '@/components/generiques/Saisie.vue';

const { idErreur, autofocus, infobulle, desactive, placeholder } = defineProps({
    idErreur: String,
    autofocus: Boolean,
    infobulle: String,
    desactive: Boolean,
    placeholder: String
});

const valeur = defineModel('valeur', {
    type: String
});


const erreursSaisie = inject('erreursSaisie');

</script>

<template>
    <Saisie :message-erreur="erreursSaisie[idErreur]">
        <input type="text" 
            v-model="valeur" 
            spellcheck="false" 
            autocomplete="aucun"
            :disabled="desactive"
            :placeholder="placeholder"
            :autofocus="autofocus" 
            v-tooltip.top="infobulle" />
    </Saisie>
</template>

<style scoped>

</style>